// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remaining-chars[data-v-66369736]{color:grey;margin-top:5px;font-size:10px}", ""]);
// Exports
module.exports = exports;
